var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto ml-0 w-full lg:mr-3"},[_c('div',{staticClass:"flex justify-start divide-x-1.5 mb-2 items-center",staticStyle:{"background-color":"#eee","opacity":"1"}},_vm._l((_vm.tabs),function(tab,index){return _c('button',{key:index,staticClass:"text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3 w-32",class:{
      'bg-primary text-white': _vm.selectedTab == tab.name,
    },on:{"click":(e) => _vm.setTab(e, tab.name)}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }